import { createSecuritySelectorFilter } from './helpers.ts'

/**
 * Filters out any node that does not have a **envVars** report alert.
 */
export const env = createSecuritySelectorFilter('env', 'envVars')
